import styled from 'styled-components'
import {CalendarStyleProps} from '../../CalendarProps'

export const YearPickerContainer = styled.div`
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  padding-top: 0;

  overflow-y: auto;
  height: 11.5rem;
  justify-content: center;
  align-items: center;

  ::-webkit-scrollbar {
    width: ${({theme}) => theme.dropdown.scrollbarWidth};
  }

  ::-webkit-scrollbar-thumb {
    background-clip: padding-box;
    background-color: ${({theme}) => theme.dropdown.scrollbarBackground};
    border-radius: 5px;
    border: 4px solid rgba(0, 0, 0, 0);
  }
`

export const YearPickerRows = styled.div`
  display: flex;
  grid-gap: 0rem 0.5rem;
  margin-bottom: 0.5rem;
`

export const YearPickerContent = styled.div<CalendarStyleProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  cursor: pointer;
  height: 2rem;
  width: 2.85rem;
  border-radius: 8px;
  background-color: ${({isSelected, theme}) => (isSelected ? theme.calendar.selectedDayBackgroundColor : theme.calendar.backgroundColor)};
  color: ${({isSelected, theme}) => (isSelected ? theme.calendar.selectedDayColor : theme.calendar.color)};

  ${({isSelected, theme, isCurrentYear}) => isCurrentYear && !isSelected && `border: 1px solid ${theme.calendar.actualDateBorder}`};

  font-family: ${({theme}) => theme.calendar.fontFamily};
  font-size: ${({theme}) => theme.calendar.fontSize};
  font-weight: ${({theme}) => theme.calendar.fontWeight};

  ${({isCurrentYear, isSelected, theme}) => isCurrentYear && !isSelected && `border: 1px solid ${theme.calendar.actualDateBorder};`};

  ${({isCurrentYear, isSelected, theme}) => isCurrentYear && !isSelected && `color: ${theme.calendar.actualDateColor};`};

  ${({isCurrentYear, isSelected, theme}) => isCurrentYear && !isSelected && `background-color: ${theme.calendar.actualDateBackgroundColor};`};

  :hover {
    background-color: ${({theme, isSelected}) => !isSelected && theme.calendar.hoverBackgroundColor};
    color: ${({theme, isSelected}) => !isSelected && theme.calendar.hoverColor};
  }
`
